module.exports = __webpack_public_path__ + "static/media/scroll-of-truth.8fe73a1a.png";